import { render, staticRenderFns } from "./AppQuickTip.vue?vue&type=template&id=44583ca2&scoped=true"
import script from "./AppQuickTip.vue?vue&type=script&lang=ts"
export * from "./AppQuickTip.vue?vue&type=script&lang=ts"
import style0 from "./AppQuickTip.vue?vue&type=style&index=0&id=44583ca2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44583ca2",
  null
  
)

export default component.exports